import CompActiveFiltersCard from './custom/ActiveFiltersCard.vue';
export const ActiveFiltersCard = CompActiveFiltersCard;
export default CompActiveFiltersCard;
